import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import LayOut from './LayOut';

const queryClient = new QueryClient();

const orgSignUp = ({ gdpr }: { gdpr: boolean }) => (
  <QueryClientProvider client={queryClient}>
    <LayOut gdpr={gdpr} />;
  </QueryClientProvider>
);

export default orgSignUp;
